import { strStartsWith } from '../../../../../services/strings';
import { inIframe } from '../../../services/app-storage';
import onMessage from '../../../services/external-messages';
import { onCurrencyChange, trySetSelectedCurrency } from './currency-storage';
import { getCurrencySwitcher } from './currency-view';

export function initCurrencyHandlers(): void {
    // On currency change:
    getCurrencySwitcher().change(function () {
        trySetSelectedCurrency(this.value as string);
    });

    // Sync with parent window
    if (inIframe) {
        onMessage(msg => {
            const currencyCode = msg.substr(9).toUpperCase();
            trySetSelectedCurrency(currencyCode).catch(e => {
                console.warn(currencyCode, 'is not a valid currency!', e);
            });
        }, msg => strStartsWith(msg, 'currency_'));

        onCurrencyChange(c => parent.postMessage('currency_' + c.code, '*'));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/bundle/currencies/currency-handlers.ts